import React, { useState, useEffect } from 'react'
import { suggestionListService, authService } from '../../_services'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import Select from 'react-select'
import { SERVER_URL } from '../../config';

function SuggestionSearch(props) {

	const [show, setShow] = useState(false)
	const [searchQuery, setSearchQuery] = useState("")
	const [suggestionLists, setSuggestionLists] = useState([])
	const [results, setResults] = useState([])
	const [listCount, setListCount] = useState(0)
	const [suggestionCount, setSuggestionCount] = useState(0)
    const {t} = useTranslation('common')

	const onClick = () => {
		setSuggestionLists([])
		setSearchQuery('')
        setResults([])
        setShow(true)
        suggestionListService.list().then(data => {
			setSuggestionLists(data)
		})
    }

    const onHide = () => {
		setShow(false)
    }

    const onSearchQueryChange = e => {
        let value = e.target.value

        setSearchQuery(value)

        if (value && value.length > 0) {
            var suggestionCount = 0
			let newFilteredSuggestionLists = suggestionLists.filter(list => {
				let suggestions = list.suggestions.filter(suggestion => suggestion.text.toUpperCase().includes(value.toUpperCase()))
				suggestionCount += suggestions.length
				return suggestions.length > 0
			})
			newFilteredSuggestionLists.sort((a, b) => a.customerName.localeCompare(b.customerName) || a.name.localeCompare(b.name, undefined, { numeric: true }))
			setResults(newFilteredSuggestionLists)
			setListCount(newFilteredSuggestionLists.length)
			setSuggestionCount(suggestionCount)
        } else {
			setResults([])
			setListCount(0)
			setSuggestionCount(0)
        }
    }

    const formatType = function(type) {
        if (type == 'DOCUMENTATION_NAMES') {
            return t('suggestionlist.types.documentationnames')
        } else if (type == 'TASK_OPTIONS') {
            return t('suggestionlist.types.taskoptions')
        } else if (type == 'CONTACT_PERSONS') {
            return t('suggestionlist.types.contactpersons')
        }
        return '-'
    }

	return (
		<>
			<Button
                key="search"
	            onClick={onClick}
	            title="Sök"
	            color="info"
	            variant="outline-dark"
	            style={{float: 'right', marginRight: 5}}>
	            {t('suggestionlist.search.button')} <FontAwesomeIcon icon={faMagnifyingGlass}/>
	        </Button>
			<Modal
				style={{overflow: 'scroll'}}
				size="xl"
				show={show}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={onHide}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('suggestionlist.search.title')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ suggestionLists.length == 0 &&
						<div style={{textAlign: 'center'}}>
							<Spinner animation="border" role="status">
								<span className="sr-only">Loading...</span>
							</Spinner>
						</div>
					}
					{ suggestionLists.length > 0 &&
						<input
							type="text"
							id="searchQuery"
							className="form-control"
							value={searchQuery}
							onChange={onSearchQueryChange}
							placeholder={t('suggestionlist.search.title')}
							style={{width: 300}}
							autoFocus
						/>
					}
					{ results.length > 0 &&
						<table className="table table-bordered" style={{marginTop: 10}}>
							<thead>
								<tr>
									{ authService.hasRoles(['ROLE_SUPER_ADMIN']) &&
										<th>
											{t('suggestionlist.columns.customer')}
										</th>
									}
									<th>
										{t('suggestionlist.columns.name')}
									</th>
									<th>
										{t('suggestionlist.columns.description')}
									</th>
									<th>
										{t('suggestionlist.columns.type')}
									</th>
									<th>
										{t('suggestion.columns.text')}
									</th>
									<th>
										{t('suggestion.columns.datecreated')}
									</th>
									<th>
										{t('suggestion.columns.imported')}
									</th>
								</tr>
							</thead>
							<tbody>
								{ results.map(suggestionList => {
									return <tr key={suggestionList.id}>
										{ authService.hasRoles(['ROLE_SUPER_ADMIN']) &&
											<td>
												{suggestionList.customerName}
											</td>
										}
										<td>
											{suggestionList.name}
										</td>
										<td>
											{suggestionList.description || '-'}
										</td>
										<td>
											{formatType(suggestionList.type)}
										</td>
										<td>
											{ suggestionList.suggestions.filter(suggestion => suggestion.text.toUpperCase().includes(searchQuery.toUpperCase())).map(suggestion => {
												return <div key={'text-' + suggestion.id}>
													{suggestion.text}
												</div>
											})}
										</td>
										<td>
											{ suggestionList.suggestions.filter(suggestion => suggestion.text.toUpperCase().includes(searchQuery.toUpperCase())).map(suggestion => {
												return <div key={'dateCreated-' + suggestion.id}>
													{moment(suggestion.dateCreated).format('YYYY-MM-DD HH:mm:ss')}
												</div>
											})}
										</td>
										<td>
											{ suggestionList.suggestions.filter(suggestion => suggestion.text.toUpperCase().includes(searchQuery.toUpperCase())).map(suggestion => {
												return <div key={'text-' + suggestion.id}>
													{suggestion.imported ? t('crudtable.yes') : t('crudtable.no')}
												</div>
											})}
										</td>
									</tr>
								})}
							</tbody>
						</table>
					}
					{ suggestionLists.length > 0 && searchQuery &&
						<div style={{paddingTop: 5}}>
							{t('suggestionlist.search.count', { suggestionCount: suggestionCount, listCount: listCount })}
						</div>
					}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="outline-primary" onClick={onHide}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default SuggestionSearch